/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Timeline_Zoom_InInputs */

const en_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom In`)
};

const fr_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoomer`)
};

const de_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrößern`)
};

const it_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrandisci`)
};

const ru_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличить масштаб`)
};

const es_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dar un golpe de zoom`)
};

const zh_cn2_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大`)
};

const ja_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズームイン`)
};

const hi_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम इन`)
};

const pt_pt2_shortcut_keys_name_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar`)
};

/**
* | output |
* | --- |
* | "Zoom In" |
*
* @param {Shortcut_Keys_Name_Timeline_Zoom_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_timeline_zoom_in = /** @type {((inputs?: Shortcut_Keys_Name_Timeline_Zoom_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Timeline_Zoom_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_timeline_zoom_in(inputs)
	if (locale === "de") return de_shortcut_keys_name_timeline_zoom_in(inputs)
	if (locale === "it") return it_shortcut_keys_name_timeline_zoom_in(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_timeline_zoom_in(inputs)
	if (locale === "es") return es_shortcut_keys_name_timeline_zoom_in(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_timeline_zoom_in(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_timeline_zoom_in(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_timeline_zoom_in(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_timeline_zoom_in(inputs)
	return en_shortcut_keys_name_timeline_zoom_in(inputs)
});